import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=41b27968&scoped=true&"
import script from "./legend.vue?vue&type=script&lang=js&"
export * from "./legend.vue?vue&type=script&lang=js&"
import style0 from "./legend.vue?vue&type=style&index=0&id=41b27968&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b27968",
  null
  
)

export default component.exports